import { VectorIconWrapper } from '@/containers/SearchFlightTab';
import { LocationSearchType } from '@/containers/SearchFlightTab/SearchDialog/index.d';
import SearchFormInput from '@/containers/SearchFlightTabVcms/SearchFormInput';
import { addAllHomePoints } from '@/slices/area/slices/searchFlightFormSlice';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import { memo } from 'react';
import { useDispatch } from 'react-redux';
import Image from '@/containers/SearchFlightTabVcms/Image';
import styled from '@mui/styled-engine';
import { Dialog } from '@mui/material';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const pickupIcon = 'https://storage.googleapis.com/fe-production/svgIcon/pickup_vex_blue_24dp.svg';
const dropoffIcon = 'https://storage.googleapis.com/fe-production/svgIcon/pickup_negative_24dp.svg';
const lineRouteIcon = 'https://storage.googleapis.com/fe-production/svgIcon/line-route.svg';
const switchIcon = 'https://storage.googleapis.com/fe-production/svgIcon/import_export_dark_24dp.svg';

export const ContainerEl = styled('div')`
`;

const StyledDialog = styled(Dialog)`
  .MuiButtonBase-root.MuiTab-root.Mui-selected {
    color: black;
  }
  .MuiTabs-indicator {
    background: black;
  }
  .MuiPaper-root > .MuiTabs-root {
    height: 5em;
  }
`;

const StyledGridContainer = styled('div')`
  display: block;
  margin-top: 12px;
  margin-bottom: 10px;
`;

export const Caption = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.1px;
  margin-bottom: 0;
  margin-top: 0;
  word-break: break-word;
`;

export const Headline = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.25px;
  margin-bottom: 0;
  margin-top: 0;
  word-break: break-word;
`;

export const ButtonLabel = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 0;
  word-break: break-word;
  margin-top: 0px;
`;

const Container = styled('div')`
  &.search-widget-section {
    // padding: 16px 20px;
    background: #fff;
    .from-name,
    .to-name,
    .bus-name {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .search-widget {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-radius: 8px;
      box-shadow: 0px 4px 32px -4px rgba(0, 0, 0, 0.16);
      background: ${style.neutral.white};

      .icon-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 16px;
      }

      .from-to-section {
        display: flex;
        flex-direction: row;
        min-height: 80px;
      }

      .from-select,
      .to-select {
        display: flex;
        flex-direction: column;
        height: 64px;
        justify-content: center;
      }

      .from-select {
        border-bottom: 0.5px solid ${style.neutral.lightBorder};
      }

      .from-to-select-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        padding-right: 56px;

        .switch-route-icon {
          position: absolute;
          top: 48px;
          right: 16px;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
        }
      }

      .divider {
        margin-left: 16px;
        border-bottom: 0.5px solid ${style.neutral.lightBorder};
      }
    }

    .search-btn {
      width: 100%;
      margin-top: 16px;
      height: auto;
      padding: 12px 16px;
      border-radius: 8px;

      p {
        display: inline-block;
      }
    }
  }
`;

const DateInputSt = styled('div')`
`;

function SearchMiniInputVcms({
  lang, startPoint, toPoint, switchUpdateSecondTime, isFirstTime,
}: { lang?: ILangObj, startPoint?: any, toPoint?: any, switchUpdateSecondTime?: any, isFirstTime?: any }) {
  const dispatch = useDispatch();

  return (
    // <div style={{ position: 'relative' }}>
    //   <SearchFormInput
    //     type={LocationSearchType.FROM}
    //   />
    //   <SearchFormInput
    //     type={LocationSearchType.TO}
    //   />
    //   <VectorIconWrapper>
    //     <IconButton
    //       onClick={() => {
    //         dispatch(addAllHomePoints([
    //           {
    //             data: startPoint,
    //             type: 'to',
    //           }, {
    //             data: toPoint,
    //             type: 'from',
    //           },
    //         ]));
    //       }}
    //       style={{
    //         width: 40,
    //         height: 40,
    //       }}
    //     >
    //       <VectorIcon color={style.color.black4} />
    //     </IconButton>
    //   </VectorIconWrapper>
    // </div>
    <Container className="search-widget-section">
      <div className="search-widget bg--white">
        <div className="from-to-section">
          <div className="icon-container">
            <Image
              imageSrc={pickupIcon}
              alt="pickup-icon"
              className="pickup-icon"
              imageProps={{
                width: 24,
                height: 24,
              }}
            />

            <Image
              imageSrc={lineRouteIcon}
              alt="line-route-icon"
              className="line-route-icon"
              imageProps={{
                width: 24,
                height: 34,
              }}
            />

            <Image
              imageSrc={dropoffIcon}
              alt="dropoff-icon"
              className="dropoff-icon"
              imageProps={{
                width: 24,
                height: 24,
              }}
            />
          </div>

          <div className="from-to-select-container">
            <div
              className="search-widget-home from-select"
              id="from-select"
            >
              <SearchFormInput
                isGetFromSeo={isFirstTime}
                type={LocationSearchType.FROM}
                miniSeo
                lang={lang}
                point={startPoint}
                onOpenSearchDialog={switchUpdateSecondTime}
              />
            </div>

            <ContainerEl
              className="switch-route-icon bg--lightest-bg"
              onClick={() => {
                dispatch(
                  addAllHomePoints([
                    {
                      data: startPoint,
                      type: 'to',
                    },
                    {
                      data: toPoint,
                      type: 'from',
                    },
                  ]),
                );
              }}
            >
              <Image
                imageSrc={switchIcon}
                alt="switch-icon"
                className="switch-icon"
                imageProps={{
                  width: 24,
                  height: 24,
                }}
              />
            </ContainerEl>

            <div
              className="search-widget-home to-select"
              id="to-select"
            >
              <SearchFormInput
                isGetFromSeo={isFirstTime}
                onOpenSearchDialog={switchUpdateSecondTime}
                type={LocationSearchType.TO}
                miniSeo
                lang={lang}
                point={toPoint}
              />
            </div>
          </div>
        </div>
      </div>
    </Container>

  );
}

export default memo(SearchMiniInputVcms);
